import $ from "jquery";
import axios from "axios";

$(() => {
    $(".load-more").on("click", function () {
        const id = $(this).data("id");
        // Read the raw attribute rather than the jQuery-parsed object: the signature
        // is over this exact string, so re-serialising it would break verification.
        const fields = $(this).attr("data-fields");
        const fieldsSignature = $(this).attr("data-fields-signature");
        if (!fields) {
            return;
        }

        const initialOffset = $(this).data("initial-offset") ?? 0;
        const offset = $(`#${id} .cards .item-card:not([class$="included"])`).length ?? 0;
        const masonry = $(this).data("is-masonry") ?? 0;
        const slider = $(this).data("is-slider") ?? 0;
        const textLoadMore = $(this).data("text-load-more");
        const textLoading = $(this).data("text-loading");
        const textLoadFailed = $(this).data("text-load-failed");

        // Data to send back to WordPress.
        const formData = new FormData();
        formData.append("action", "wpsoup_load_posts_by_ajax");
        formData.append("security", frameworkGlobal.nonce);
        formData.append("offset", initialOffset + offset);
        formData.append("fields", fields);
        formData.append("fields_signature", fieldsSignature ?? "");

        // Change button text to loading text.
        $(`#${id} .load-more`).html(textLoading);

        // Do request.
        axios
            .post(frameworkGlobal.ajaxurl, formData)
            .then(({ data }) => {
                // Create a placeholder div to store retrieved posts.
                const container = document.createElement("div");
                container.innerHTML = data;

                // Extract only the item-card elements from the response
                const newCards = container.querySelectorAll(".item-card");

                // Append the card elements
                newCards.forEach((card) => {
                    $(`#${id} .cards`).append(card.cloneNode(true));
                });

                // If retrieved posts length is smaller than the amount to load, hide the button
                if (newCards.length < fields.ajax_amount_to_load) {
                    $(`#${id} .load-more-container`).remove();
                } else {
                    // Update button text back to load more
                    $(`#${id} .load-more`).html(textLoadMore);
                }

                // Reinit masonry or equalizer.
                if (slider) {
                    const instance = cardSliders.find((x) => x.id === id).instance;
                    instance.update();
                }

                // Reinit masonry or equalizer.
                if (masonry) {
                    const container = masonryGrids.find((x) => x.id === id).container;
                    window.masonryGridPolyfill(container, true, true);
                } else {
                    Foundation.reInit("equalizer");
                }
            })
            .catch((error) => {
                $(`#${id} .load-more`).html(textLoadFailed);
            });
    });
});
